// The full unit page's tab panels, by today's tab id (utils/unitRoute.js).
import IntelligenceTabV2 from './IntelligenceTabV2';
import AskTabV2 from './AskTabV2';
import OverviewTabV2 from './OverviewTabV2';
import ServiceTabV2 from './ServiceTabV2';
import PhotosTabV2 from './PhotosTabV2';
import PricingTabV2 from './PricingTabV2';
import PipelineTabV2 from './PipelineTabV2';
import CompsTabV2 from './CompsTabV2';
import ActivityTabV2 from './ActivityTabV2';

const TAB_PANELS = Object.freeze({
    ai: IntelligenceTabV2,
    fasttrack: AskTabV2,
    overview: OverviewTabV2,
    service: ServiceTabV2,
    photos: PhotosTabV2,
    pricing: PricingTabV2,
    pipeline: PipelineTabV2,
    comps: CompsTabV2,
    activity: ActivityTabV2,
});

export default TAB_PANELS;
